// src/features/auth/components/LoginForm.jsx
import React, { useState } from 'react';
import { useLogin } from '../hooks/useLogin';
import {showSuccess, showError, showWarning} from '../../../utils/toastHelper';
import {TbDeviceMobileCheck} from "react-icons/tb";
import {useNavigate} from "react-router-dom";

const LoginForm = () => {
    const navigate = useNavigate();
    const initMobile = window.localStorage.getItem("mobile") ? window.localStorage.getItem("mobile") : '';
    const [mobile, setMobile] = useState(initMobile);
    const { login, loading } = useLogin();
    const [buttonStatus, setButtonStatus] = useState(initMobile.length <= 1,);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const result = await login(mobile);
            window.localStorage.setItem("mobile", mobile);
            if (result?.success) {
                showSuccess(result.data.message || 'کد تایید ارسال شد');
                if(result.data.data.otp) {
                    window.localStorage.setItem("OTP", result.data.data.otp);
                }
                setTimeout (() => {
                    navigate("/verify");
                },1000)
            }
        } catch (err) {
            showError(err);
        }
    };


    return (
        <form onSubmit={handleSubmit} className="p-4  rounded shadow-sm bg-white">


            <div className="mb-3">
                <div className="input-group mb-3">

                    <div className="form-floating ">
                        <input type="number"
                               className="form-control text-center text-big-3" id="mobile"
                               placeholder="شماره موبایل"
                               value={mobile}
                               autoFocus={true}
                               onChange={(e) => {
                                   const mobile = e.target.value;
                                   if (mobile.length >= 12) {
                                       return false;
                                   }
                                   if (mobile[0] === '0' && mobile[1] === '9' && mobile.length === 11) {
                                       setButtonStatus(false)
                                   } else {
                                       setButtonStatus(true)
                                   }
                                   setMobile(mobile);
                               }
                               }
                               required
                        />
                        <label htmlFor="mobile" className='right-0'>شماره موبایل</label>
                    </div>
                    <span className="input-group-text">
                        <TbDeviceMobileCheck className='text-big-5' />
                    </span>
                </div>


            </div>


            <button type="submit" className="btn text-white w-100 bg-primary-color custom-button mt-4"
                    disabled={loading || buttonStatus}
            >
                {loading ? 'در حال ارسال...' : 'ادامه'}
            </button>

            <div className='mt-4 text-center'>
               <span
                   className='btn border-0'
                   onClick={ () => {

                       if (mobile[0] === '0' && mobile[1] === '9' && mobile.length === 11) {
                           window.localStorage.setItem("mobile", mobile);
                           window.localStorage.setItem("type", 'password');
                           navigate("/verify");
                       } else {
                           showWarning('لطفا ابتدا شماره موبایل خود را کامل وارد کنید')
                       }

                   }}

               >
                   ورود با رمز عبور
               </span>
            </div>
        </form>

    );
};

export default LoginForm;
